export enum AppType {
    Worker = 'worker',
    Empoloyer = 'employer',
    Recruiter = 'recruiter',
}

export enum Loading {
    App,
    SpecialityAutocomplete,
    CityAutocomplete,
    AutocompleteOptions,
    ResponseHistory,
    WorkerInvitation,
    VerificationCode
}

export enum Rate {
    Hourly = 'hourly',
    Monthly = 'monthly',
}

export enum Gender {
    Male = 'male',
    Female = 'female',
}

export enum SortDirection {
    Asc = 'asc',
    Desc = 'desc',
}

export enum OnlineStatus {
    Online = 'online',
    Offline = 'offline',
}

export enum ContactDetailsType {
    Phone = 'phone',
    Email = 'email',
}

export enum Messenger {
    Viber = 'viber',
    Telegram = 'telegram',
    Whatsapp = 'whatsapp',
    None = 'none',
}
